/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {LineChart} from '../../../../components/Charts/LineChart/LineChart'
import Chart from 'react-apexcharts'
import {GET} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import {Loading} from '../../../../components/Loading/Loading'
import moment from 'moment'
import {i18n} from '../../../../translate/i18n'
import styles from './index.module.css'
import {toMoney} from '../../../../utils/formater'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import useAuth from '../../../../hooks/useAuth'

type TimeItemsResponseType = {
  month?: string
  day?: string
  hour?: string
  total: number
  sales: string
  timeNumber: number
}

type TimeItemsType = {
  month?: string
  day?: string
  hour?: string
  total: number
  sales: number
}

type TimeItemsSectorResponseType = {
  month?: string
  day?: string
  hour?: string
  total: number
  sales: string
  timeNumber?: number
  location: string
  locationCode: string
}

type TimeItemsSectorType = {
  month?: string
  day?: string
  hour?: string
  total: number
  sales: number
  location: string
  locationCode: string
}

const PedidosContent: FC = () => {
  const [startDate, setStartDate] = useState('')
  const [finalDate, setFinalDate] = useState('')

  const [loading, setLoading] = useState(false)
  const [totalValuesByMonth, setTotalValuesByMonth] = useState<TimeItemsType[]>([])
  const [totalValuesByDay, setTotalValuesByDay] = useState<TimeItemsType[]>([])
  const [totalValuesByHour, setTotalValuesByHour] = useState<TimeItemsType[]>([])

  const [totalValuesBySector, setTotalValuesBySector] = useState<TimeItemsSectorType[]>([])

  const [monthsSector, setMonthsSector] = useState<string[]>([])
  const [valueMonthsSectorDelivery, setValueMonthsSectorDelivery] = useState<number[]>([])
  const [valueMonthsSectorWithdrawal, setValueMonthsSectorWithdrawal] = useState<number[]>([])

  const [daysSector, setDaysSector] = useState<string[]>([])
  const [valueDaysSectorDelivery, setValueDaysSectorDelivery] = useState<number[]>([])
  const [valueDaysSectorWithdrawal, setValueDaysSectorWithdrawal] = useState<number[]>([])

  const [hoursSector, setHoursSector] = useState<string[]>([])
  const [valueHoursSectorDelivery, setValueHoursSectorDelivery] = useState<number[]>([])
  const [valueHoursSectorWithdrawal, setValueHoursSectorWithdrawal] = useState<number[]>([])

  const [totalSales, setTotalSales] = useState(0)
  const [totalValue, setTotalValue] = useState(0)

  const {loginInfo} = useAuth()

  const getItems = async () => {
    try {
      setLoading(true)
      const allMonthRes = await GET('/dashboard/seller-all-times?')
      const allDayRes = await GET('/dashboard/seller-all-times?time=day')
      const allHourRes = await GET('/dashboard/seller-all-times?time=hour')
      const allResSector = await GET('/dashboard/seller-all-times-sector?')
      const allResSectorMonth = await GET('/dashboard/seller-all-times-sector?time=month')
      const allResSectorDay = await GET('/dashboard/seller-all-times-sector?time=day')
      const allResSectorHour = await GET('/dashboard/seller-all-times-sector?time=hour')

      setLoading(false)
      let totalSalesItem = 0
      let totalValueItem = 0
      setTotalValuesByMonth(
        allMonthRes.data.map((monthItem: TimeItemsResponseType) => {
          totalSalesItem += parseInt(monthItem.sales)
          totalValueItem += monthItem.total
          return {
            month: monthItem.month,
            total: monthItem.total.toFixed(2),
            sales: parseInt(monthItem.sales),
          }
        })
      )
      setTotalSales(totalSalesItem)
      setTotalValue(totalValueItem)

      setTotalValuesByDay(
        allDayRes.data.map((dayItem: TimeItemsResponseType) => ({
          day: dayItem.day,
          total: dayItem.total.toFixed(2),
          sales: parseInt(dayItem.sales),
        }))
      )

      setTotalValuesByHour(
        allHourRes.data.map((hourItem: TimeItemsResponseType) => ({
          hour: hourItem.hour + 'h',
          total: hourItem.total.toFixed(2),
          sales: parseInt(hourItem.sales),
        }))
      )

      const dataSector: TimeItemsSectorType[] = []
      allResSector.data.forEach((sectorItem: TimeItemsSectorResponseType) => {
        const dataExist = dataSector.findIndex(
          (oldValues) => oldValues.location === sectorItem.location
        )
        if (dataExist !== -1) {
          dataSector[dataExist].total += sectorItem.total
          dataSector[dataExist].sales = parseInt(sectorItem.sales) + dataSector[dataExist].sales
        } else {
          dataSector.push({
            location: sectorItem.location,
            locationCode: sectorItem.locationCode,
            total: parseFloat(sectorItem.total.toFixed(2)),
            sales: parseInt(sectorItem.sales),
          })
        }
      })
      setTotalValuesBySector(dataSector)

      const months: string[] = []
      let delivery: number[] = []
      let withdraw: number[] = []
      allResSectorMonth.data.forEach((item: TimeItemsSectorResponseType) => {
        if (item.month && !months.includes(item.month)) {
          months.push(item.month)
        }
      })
      months.forEach((month: string, index: number) => {
        delivery[index] = 0
        allResSectorMonth.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.month === month && item.locationCode === 'delivery') {
            delivery[index] += parseInt(item.sales)
          }
        })
      })
      months.forEach((month: string, index: number) => {
        withdraw[index] = 0
        allResSectorMonth.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.month === month && item.locationCode === 'withdraw') {
            withdraw[index] += parseInt(item.sales)
          }
        })
      })
      setMonthsSector(months)
      setValueMonthsSectorDelivery(delivery)
      setValueMonthsSectorWithdrawal(withdraw)

      const days: string[] = []
      delivery = []
      withdraw = []
      allResSectorDay.data.forEach((item: TimeItemsSectorResponseType) => {
        if (item.day && !days.includes(item.day)) {
          days.push(item.day)
        }
      })
      days.forEach((day: string, index: number) => {
        delivery[index] = 0
        allResSectorDay.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.day === day && item.locationCode === 'delivery') {
            delivery[index] += parseInt(item.sales)
          }
        })
      })
      days.forEach((day: string, index: number) => {
        withdraw[index] = 0
        allResSectorDay.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.day === day && item.locationCode === 'withdraw') {
            withdraw[index] += parseInt(item.sales)
          }
        })
      })

      setDaysSector(days)
      setValueDaysSectorDelivery(delivery)
      setValueDaysSectorWithdrawal(withdraw)

      const hours: string[] = []
      delivery = []
      withdraw = []
      allResSectorHour.data.forEach((item: TimeItemsSectorResponseType) => {
        if (item.hour && !hours.includes(item.hour + 'h')) {
          hours.push(item.hour + 'h')
        }
      })
      hours.forEach((hour: string, index: number) => {
        delivery[index] = 0
        allResSectorHour.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.hour + 'h' === hour && item.locationCode === 'delivery') {
            delivery[index] += parseInt(item.sales)
          }
        })
      })
      hours.forEach((hour: string, index: number) => {
        withdraw[index] = 0
        allResSectorHour.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.hour + 'h' === hour && item.locationCode === 'withdraw') {
            withdraw[index] += parseInt(item.sales)
          }
        })
      })
      setHoursSector(hours)
      setValueHoursSectorDelivery(delivery)
      setValueHoursSectorWithdrawal(withdraw)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const getItemsFiltered = async (once?: boolean) => {
    try {
      setLoading(true)
      const allMonthRes = await GET(
        `/dashboard/seller-all-times?startDate=${startDate}&finalDate=${finalDate}`
      )
      const allDayRes = await GET(
        `/dashboard/seller-all-times?startDate=${startDate}&finalDate=${finalDate}&time=day`
      )
      const allHourRes = await GET(
        `/dashboard/seller-all-times?startDate=${startDate}&finalDate=${finalDate}&time=hour`
      )
      const allResSector = await GET(
        `/dashboard/seller-all-times-sector?startDate=${startDate}&finalDate=${finalDate}`
      )
      const allResSectorMonth = await GET(
        `/dashboard/seller-all-times-sector?startDate=${startDate}&finalDate=${finalDate}&time=month`
      )
      const allResSectorDay = await GET(
        `/dashboard/seller-all-times-sector?startDate=${startDate}&finalDate=${finalDate}&time=day`
      )
      const allResSectorHour = await GET(
        `/dashboard/seller-all-times-sector?startDate=${startDate}&finalDate=${finalDate}&time=hour`
      )
      setLoading(false)

      let totalSalesItem = 0
      let totalValueItem = 0

      setTotalValuesByMonth(
        allMonthRes.data.map((monthItem: TimeItemsResponseType) => {
          totalSalesItem += parseInt(monthItem.sales)
          totalValueItem += monthItem.total
          return {
            month: monthItem.month,
            total: monthItem.total.toFixed(2),
            sales: parseInt(monthItem.sales),
          }
        })
      )
      setTotalSales(totalSalesItem)
      setTotalValue(totalValueItem)

      setTotalValuesByDay(
        allDayRes.data.map((dayItem: TimeItemsResponseType) => ({
          day: dayItem.day,
          total: dayItem.total.toFixed(2),
          sales: parseInt(dayItem.sales),
        }))
      )

      setTotalValuesByHour(
        allHourRes.data.map((hourItem: TimeItemsResponseType) => ({
          hour: hourItem.hour + 'h',
          total: hourItem.total.toFixed(2),
          sales: parseInt(hourItem.sales),
        }))
      )

      const dataSector: TimeItemsSectorType[] = []
      allResSector.data.forEach((sectorItem: TimeItemsSectorResponseType) => {
        const dataExist = dataSector.findIndex(
          (oldValues) => oldValues.location === sectorItem.location
        )
        if (dataExist !== -1) {
          dataSector[dataExist].total += sectorItem.total
          dataSector[dataExist].sales = parseInt(sectorItem.sales) + dataSector[dataExist].sales
        } else {
          dataSector.push({
            location: sectorItem.location,
            locationCode: sectorItem.locationCode,
            total: parseFloat(sectorItem.total.toFixed(2)),
            sales: parseInt(sectorItem.sales),
          })
        }
      })
      setTotalValuesBySector(dataSector)

      const months: string[] = []
      let delivery: number[] = []
      let withdraw: number[] = []
      allResSectorMonth.data.forEach((item: TimeItemsSectorResponseType) => {
        if (item.month && !months.includes(item.month)) {
          months.push(item.month)
        }
      })
      months.forEach((month: string, index: number) => {
        delivery[index] = 0
        allResSectorMonth.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.month === month && item.locationCode === 'delivery') {
            delivery[index] += parseInt(item.sales)
          }
        })
      })
      months.forEach((month: string, index: number) => {
        withdraw[index] = 0
        allResSectorMonth.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.month === month && item.locationCode === 'withdraw') {
            withdraw[index] += parseInt(item.sales)
          }
        })
      })
      setMonthsSector(months)
      setValueMonthsSectorDelivery(delivery)
      setValueMonthsSectorWithdrawal(withdraw)

      const days: string[] = []
      delivery = []
      withdraw = []
      allResSectorDay.data.forEach((item: TimeItemsSectorResponseType) => {
        if (item.day && !days.includes(item.day)) {
          days.push(item.day)
        }
      })
      days.forEach((day: string, index: number) => {
        delivery[index] = 0
        allResSectorDay.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.day === day && item.locationCode === 'delivery') {
            delivery[index] += parseInt(item.sales)
          }
        })
      })
      days.forEach((day: string, index: number) => {
        withdraw[index] = 0
        allResSectorDay.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.day === day && item.locationCode === 'withdraw') {
            withdraw[index] += parseInt(item.sales)
          }
        })
      })

      setDaysSector(days)
      setValueDaysSectorDelivery(delivery)
      setValueDaysSectorWithdrawal(withdraw)

      const hours: string[] = []
      delivery = []
      withdraw = []
      allResSectorHour.data.forEach((item: TimeItemsSectorResponseType) => {
        if (item.hour && !hours.includes(item.hour + 'h')) {
          hours.push(item.hour + 'h')
        }
      })
      hours.forEach((hour: string, index: number) => {
        delivery[index] = 0
        allResSectorHour.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.hour + 'h' === hour && item.locationCode === 'delivery') {
            delivery[index] += parseInt(item.sales)
          }
        })
      })
      hours.forEach((hour: string, index: number) => {
        withdraw[index] = 0
        allResSectorHour.data.forEach((item: TimeItemsSectorResponseType) => {
          if (item.hour + 'h' === hour && item.locationCode === 'withdraw') {
            withdraw[index] += parseInt(item.sales)
          }
        })
      })
      setHoursSector(hours)
      setValueHoursSectorDelivery(delivery)
      setValueHoursSectorWithdrawal(withdraw)

      if (!once) {
        await getItemsFiltered(true)
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  useEffect(() => {
    getItems()
    setStartDate(moment().format('YYYY-MM-DD'))
    setFinalDate(moment().format('YYYY-MM-DD'))
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders`)}
                  </span>
                  <BreadCrumbs />
                  {loginInfo.plugintype === 'food' && (
                    <span className='text-muted mt-1 fw-bold fs-7'>
                      Abaixo, são apresentados os pedidos com os status esperando coleta, coletando,
                      em trânsito e pronto de acordo com o período filtrado
                    </span>
                  )}
                  {loginInfo.plugintype === 'fashion' && (
                    <span className='text-muted mt-1 fw-bold fs-7'>
                      Abaixo, são apresentados os pedidos com os status em faturamento, parcialmente
                      atendido e atendido de acordo com o período filtrado
                    </span>
                  )}
                  {loginInfo.plugintype === 'varejo' && (
                    <span className='text-muted mt-1 fw-bold fs-7'>
                      Abaixo, são apresentados os pedidos com os status faturamento, separado,
                      entregue e entregue pela loja de acordo com o período filtrado
                    </span>
                  )}
                  {loginInfo.plugintype === 'hospitality' && (
                    <span className='text-muted mt-1 fw-bold fs-7'>
                      Abaixo, são apresentados os pedidos com o status entregue pela loja de acordo
                      com o período filtrado
                    </span>
                  )}
                </h3>
              </div>
              <div className='card-body'>
                <div>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>
                      {i18n.t(`indicators.filters`)}
                    </span>
                  </h3>
                </div>
                <div className='d-flex gap-5 flex-wrap'>
                  <Input
                    inputAttr={{
                      type: 'date',
                    }}
                    label={i18n.t(`indicators.first`)}
                    value={startDate}
                    change={(value: string) => setStartDate(value)}
                  />
                  <Input
                    inputAttr={{
                      type: 'date',
                    }}
                    label={i18n.t(`indicators.end`)}
                    value={finalDate}
                    change={(value: string) => setFinalDate(value)}
                  />
                  <div className='d-flex align-items-end'>
                    <Button
                      text={i18n.t(`buttons.filter`)}
                      color='primary'
                      size='small'
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => getItemsFiltered()}
                      btnClass='fw-bolder mb-1'
                      verticalPadding={3}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5 flex-wrap'>
            <div className='d-flex flex-row flex-wrap' style={{flex: 0.3}}>
              <div className='d-flex justify-content-between gap-5' style={{flex: 1}}>
                <div className='card mb-5 w-100'>
                  <div className='card-header'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`indicators.summary`)}
                      </span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className={styles.cardsItems}>
                      <div className={styles.cardOrders}>
                        <svg
                          width='18'
                          height='13'
                          viewBox='0 0 18 13'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M1.10938 3.19531L2.23047 0.925781C2.3125 0.761719 2.50391 0.652344 2.69531 0.679688L9.39453 1.5L7.09766 5.30078C6.90625 5.65625 6.49609 5.82031 6.11328 5.71094L1.65625 4.42578C1.10938 4.28906 0.863281 3.6875 1.10938 3.19531ZM9.39453 1.5L16.0664 0.679688C16.2578 0.652344 16.4492 0.734375 16.5312 0.925781L17.6523 3.19531C17.8984 3.6875 17.6523 4.28906 17.1055 4.42578L12.6484 5.71094C12.2656 5.82031 11.8555 5.65625 11.6641 5.30078L9.39453 1.5ZM9.33984 3.25H9.42188H9.33984ZM15.082 5.92969L16.3945 5.54688V10.1133C16.3945 10.7148 15.9844 11.2344 15.3828 11.3984L9.80469 12.793C9.53125 12.8477 9.23047 12.8477 8.95703 12.793L3.37891 11.3984C2.80469 11.2344 2.39453 10.7148 2.39453 10.1133V5.54688L3.70703 5.92969V10.1133L8.73828 11.3711V4.78125C8.73828 4.42578 9.01172 4.125 9.39453 4.125C9.75 4.125 10.0508 4.42578 10.0508 4.78125V11.3711L15.082 10.1133V5.92969Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.orders`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{totalSales}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <svg
                          width='15'
                          height='15'
                          viewBox='0 0 15 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M5.0625 3.15625C5.0625 3.18359 5.0625 3.18359 5.0625 3.21094C5.08984 3.23828 5.11719 3.29297 5.19922 3.34766C5.19922 3.375 5.22656 3.375 5.22656 3.375C4.70703 3.40234 4.21484 3.42969 3.75 3.51172V3.15625C3.75 2.66406 3.99609 2.28125 4.32422 2.00781C4.625 1.70703 5.03516 1.48828 5.5 1.32422C6.42969 0.96875 7.66016 0.75 9 0.75C10.3125 0.75 11.543 0.96875 12.4727 1.32422C12.9375 1.48828 13.3477 1.70703 13.6484 2.00781C13.9766 2.28125 14.25 2.66406 14.25 3.15625V6V8.84375C14.25 9.33594 13.9766 9.74609 13.6484 10.0195C13.3477 10.293 12.9375 10.5391 12.4727 10.7031C12.1992 10.8125 11.9258 10.8945 11.625 10.9766V9.60938C11.7617 9.58203 11.8711 9.52734 12.0078 9.47266C12.3633 9.33594 12.6367 9.17188 12.7734 9.0625C12.8555 8.98047 12.8828 8.92578 12.9102 8.89844C12.9375 8.87109 12.9375 8.87109 12.9375 8.87109V7.66797C12.7734 7.72266 12.6367 7.80469 12.4727 7.85938C12.1992 7.96875 11.9258 8.05078 11.625 8.13281V6.76562C11.7617 6.73828 11.8711 6.68359 12.0078 6.62891C12.3633 6.49219 12.6367 6.32812 12.7734 6.21875C12.8555 6.13672 12.8828 6.08203 12.9102 6.05469C12.9375 6.02734 12.9375 6.02734 12.9375 6.02734V4.82422C12.7734 4.87891 12.6367 4.96094 12.4727 5.01562C12.0898 5.15234 11.6797 5.28906 11.2148 5.37109C11.0781 5.15234 10.9141 4.98828 10.75 4.85156C10.4766 4.60547 10.1484 4.38672 9.82031 4.22266C10.6953 4.16797 11.4336 4.00391 12.0078 3.78516C12.3633 3.64844 12.6367 3.48438 12.7734 3.34766C12.8555 3.29297 12.8828 3.23828 12.9102 3.21094C12.9375 3.18359 12.9375 3.18359 12.9375 3.15625C12.9375 3.15625 12.9375 3.15625 12.9102 3.12891C12.8828 3.10156 12.8555 3.04688 12.7734 2.96484C12.6367 2.82812 12.3633 2.69141 12.0078 2.55469C11.2695 2.25391 10.2031 2.0625 9 2.0625C7.76953 2.0625 6.70312 2.25391 5.96484 2.55469C5.60938 2.69141 5.33594 2.82812 5.19922 2.96484C5.11719 3.04688 5.08984 3.10156 5.0625 3.12891C5.0625 3.15625 5.0625 3.15625 5.0625 3.15625ZM1.5625 6.65625C1.5625 6.68359 1.5625 6.68359 1.5625 6.71094C1.58984 6.73828 1.61719 6.79297 1.69922 6.84766C1.83594 6.98438 2.10938 7.14844 2.46484 7.28516C3.20312 7.55859 4.26953 7.75 5.5 7.75C6.70312 7.75 7.76953 7.55859 8.50781 7.28516C8.86328 7.14844 9.13672 6.98438 9.27344 6.84766C9.35547 6.79297 9.38281 6.73828 9.41016 6.71094C9.41016 6.68359 9.4375 6.68359 9.4375 6.65625C9.4375 6.65625 9.4375 6.65625 9.41016 6.62891C9.38281 6.60156 9.35547 6.54688 9.27344 6.46484C9.13672 6.32812 8.86328 6.19141 8.50781 6.05469C7.76953 5.75391 6.70312 5.58984 5.5 5.58984C4.26953 5.58984 3.20312 5.75391 2.46484 6.05469C2.10938 6.19141 1.83594 6.35547 1.69922 6.46484C1.61719 6.54688 1.58984 6.60156 1.5625 6.62891C1.5625 6.65625 1.5625 6.65625 1.5625 6.65625ZM0.25 6.65625C0.25 6.16406 0.496094 5.78125 0.824219 5.50781C1.125 5.20703 1.53516 4.98828 2 4.82422C2.92969 4.46875 4.16016 4.25 5.5 4.25C6.8125 4.25 8.04297 4.46875 8.97266 4.82422C9.4375 4.98828 9.84766 5.20703 10.1484 5.50781C10.4766 5.78125 10.75 6.16406 10.75 6.65625V9.5V12.3438C10.75 12.8359 10.4766 13.2461 10.1484 13.5195C9.84766 13.793 9.4375 14.0391 8.97266 14.2031C8.04297 14.5586 6.8125 14.75 5.5 14.75C4.16016 14.75 2.92969 14.5586 2 14.2031C1.53516 14.0391 1.125 13.8203 0.824219 13.5195C0.496094 13.2461 0.25 12.8359 0.25 12.3438V9.5V6.65625ZM9.4375 9.5V8.32422C9.27344 8.37891 9.13672 8.46094 8.97266 8.51562C8.04297 8.87109 6.8125 9.0625 5.5 9.0625C4.16016 9.0625 2.92969 8.87109 2 8.51562C1.83594 8.46094 1.69922 8.40625 1.5625 8.32422V9.5C1.5625 9.52734 1.5625 9.52734 1.5625 9.55469C1.58984 9.58203 1.61719 9.63672 1.69922 9.69141C1.83594 9.82812 2.10938 9.99219 2.46484 10.1289C3.20312 10.4023 4.26953 10.5938 5.5 10.5938C6.70312 10.5938 7.76953 10.4023 8.50781 10.1289C8.86328 9.99219 9.13672 9.82812 9.27344 9.69141C9.35547 9.63672 9.38281 9.58203 9.41016 9.55469C9.41016 9.52734 9.4375 9.52734 9.4375 9.5ZM2 11.3594C1.83594 11.3047 1.69922 11.25 1.5625 11.168V12.3438C1.5625 12.3438 1.5625 12.3711 1.5625 12.3984C1.58984 12.4258 1.61719 12.4805 1.69922 12.5352C1.83594 12.6719 2.10938 12.8359 2.46484 12.9727C3.20312 13.2461 4.26953 13.4375 5.5 13.4375C6.70312 13.4375 7.76953 13.2461 8.50781 12.9727C8.86328 12.8359 9.13672 12.6719 9.27344 12.5352C9.35547 12.4805 9.38281 12.4258 9.41016 12.3984C9.4375 12.3711 9.4375 12.3438 9.4375 12.3438V11.168C9.27344 11.2227 9.13672 11.3047 8.97266 11.3594C8.04297 11.7148 6.8125 11.9062 5.5 11.9062C4.16016 11.9062 2.92969 11.7148 2 11.3594Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.revenue`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(totalValue.toFixed(2))}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='card card-xxl-stretch' style={{flex: 0.7}}>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_location`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      labels: [''],

                      xaxis: {
                        axisBorder: {
                          show: false,
                        },
                        labels: {
                          show: false,
                        },
                        axisTicks: {
                          show: false,
                        },
                      },
                      grid: {
                        xaxis: {
                          lines: {
                            show: false,
                          },
                        },
                        yaxis: {
                          lines: {
                            show: false,
                          },
                        },
                      },
                      chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                          show: false,
                        },
                      },
                      plotOptions: {
                        bar: {
                          horizontal: true,
                        },
                      },
                      legend: {
                        position: 'bottom',
                        horizontalAlign: 'left',
                      },
                    }}
                    series={totalValuesBySector.map((sale) => {
                      return {
                        name: sale.location,
                        data: [sale.sales],
                      }
                    })}
                    type='bar'
                    height={150}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_month`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      chart: {id: 'bar-chart'},
                      xaxis: {
                        categories: totalValuesByMonth.map((monthItem) => monthItem.month),
                      },
                    }}
                    series={[
                      {
                        name: 'Pedidos por mês',
                        data: totalValuesByMonth.map((monthItem) => monthItem.sales),
                      },
                    ]}
                    type='bar'
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_day`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  {totalValuesByDay.length > 0 && (
                    <LineChart
                      nameValue='Pedidos'
                      data={totalValuesByDay.map((dayItem) => dayItem.sales)}
                      options={totalValuesByDay.map((dayItem) => (dayItem.day ? dayItem.day : ''))}
                      height={180}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_hour`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  {totalValuesByHour.length > 0 && (
                    <LineChart
                      nameValue='Pedidos'
                      data={totalValuesByHour.map((hourItem) => hourItem.sales)}
                      options={totalValuesByHour.map((hourItem) =>
                        hourItem.hour ? hourItem.hour : ''
                      )}
                      height={180}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_month_sector`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  {monthsSector.length > 0 && (
                    <Chart
                      options={{
                        chart: {id: 'bar-chart'},
                        xaxis: {
                          categories: monthsSector,
                        },
                      }}
                      series={[
                        {
                          name: 'Pedidos por mês - Entrega',
                          data: valueMonthsSectorDelivery,
                        },
                        {
                          name: 'Pedidos por mês - Retirada',
                          data: valueMonthsSectorWithdrawal,
                        },
                      ]}
                      type='bar'
                      height={220}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_day_sector`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  {daysSector.length > 0 && (
                    <Chart
                      options={{
                        chart: {id: 'bar-chart'},
                        xaxis: {
                          categories: daysSector,
                        },
                      }}
                      series={[
                        {
                          name: 'Pedidos por dia - Entrega',
                          data: valueDaysSectorDelivery,
                        },
                        {
                          name: 'Pedidos por dia - Retirada',
                          data: valueDaysSectorWithdrawal,
                        },
                      ]}
                      type='area'
                      height={220}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.orders_by_hour_sector`)}
                  </span>
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  {hoursSector.length > 0 && (
                    <Chart
                      options={{
                        chart: {id: 'bar-chart'},
                        xaxis: {
                          categories: hoursSector,
                        },
                      }}
                      series={[
                        {
                          name: 'Pedidos por horário - Entrega',
                          data: valueHoursSectorDelivery,
                        },
                        {
                          name: 'Pedidos por horário - Retirada',
                          data: valueHoursSectorWithdrawal,
                        },
                      ]}
                      type='area'
                      height={220}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const PedidosIndicadores: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`indicators.orders`), path: 'indicadores/chartorders', isActive: true},
        ]}
      >
        {i18n.t(`indicators.orders`)}
      </PageTitle>
      <PedidosContent />
    </>
  )
}

export {PedidosIndicadores}
